export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SecondaryButton.vue?vue&type=template&id=22711658&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SecondaryButton.vue?vue&type=template&id=22711658&scoped=true
// module id = 125
// module chunks = 0